'use client';

import { useIntl } from 'react-intl';
import { PageMetaData } from '@packages/modules/src/PageMetaData/PageMetaData';
import { CustomerOrders } from '@packages/order/src/components/CustomerOrders/CustomerOrders.client';
import { KimRating } from '@packages/modules/src/KimRating/KimRating.client';

const OrdersPage = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <PageMetaData page={{ type: 'myaccount', template: 'orders' }} />
      <h1>
        {formatMessage({
          id: 'OrdersPage.Headline',
          defaultMessage: 'Meine Bestellungen und Lieferungen',
        })}
      </h1>
      <p>
        {formatMessage({
          id: 'OrdersPage.Subheadline',
          defaultMessage:
            'Hier findest du eine Übersicht deiner Bestellungen und kannst ihren aktuellen Lieferstatus einsehen.',
        })}
      </p>
      <CustomerOrders />
      <KimRating pageType="myaccount" templateParams={{ x05: 'BL' }} />
    </>
  );
};

// eslint-disable-next-line import-x/no-default-export
export default OrdersPage;
